import React from 'react'

export const RadioGrid = ({ data, onNextStep }: { data: any; onNextStep: () => void }) => {
  return (
    <div className="grid grid-cols-2 gap-3 mt-8 first:mt-0">
      {data?.items.map((el: any, i: number) => (
        <button
          className="pt-8 font-semibold leading-[1.4] small-padding pb-6 px-6 bg-[#101A360A] rounded-button flex flex-col justify-start items-center"
          key={el.title + i}
          onClick={() => onNextStep()}
        >
          {el.icon && (
            <img className="mx-auto mb-5" src={el.icon} width={56} height={56} alt={el.title} />
          )}
          {el.title}
        </button>
      ))}
    </div>
  )
}
